import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue')
    },
    {
      path: '/scenarios',
      name: 'scenarios',
      component: () => import(/* webpackChunkName: "scenarios" */ '../views/Scenarios.vue')
    },
    {
      path: '/digital',
      name: 'digital',
      component: () => import(/* webpackChunkName: "scenarios" */ '../views/Digital.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '*',
      redirect: { name: 'index' }
    },
    {
      path: '/products',
      name: 'products',
      component: () => import(/* webpackChunkName: "products" */ '../views/Products.vue')
    }, {
      path: '/products/oralTrain',
      name: 'oralTrain',
      component: () => import(/* webpackChunkName: "oralTrain" */ '../views/products/OralTrain.vue')
    }, {
      path: '/products/zhishi',
      name: 'zhishi',
      component: () => import(/* webpackChunkName: "zhishi" */ '../views/products/Zhishi.vue')
    }, {
      path: '/products/shuyuAI',
      name: 'shuyuAI',
      component: () => import(/* webpackChunkName: "shuyuAI" */ '../views/products/ShuyuAI.vue')
    }, {
      path: '/products/mandarin',
      name: 'mandarin',
      component: () => import(/* webpackChunkName: "ShuyuAI_caida" */ '../views/products/ShuyuAI_caida.vue')
    }, {
      path: '/products/phonetics',
      name: 'phonetics',
      component: () => import(/* webpackChunkName: "phonetics" */ '../views/products/Phonetics.vue')
    }, {
      path: '/products/showMatch',
      name: 'showMatch',
      component: () => import(/* webpackChunkName: "phonetics" */ '../views/products/ShowMatch.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js